module.exports = __webpack_public_path__ + "static/media/p8.255166f5.png";